import { useEffect, useRef } from 'react';
/**
 * A hook that replaces componentDidUpdate and does not execute on mount
 *
 * @param {() => void} callback The hook callback
 * @param {React.DependencyList} dependencies Array of items that, when one changes, it triggers the hook to execute
 */
export var useDidUpdate = function (callback, dependencies) {
    var hasMount = useRef(false);
    useEffect(function () {
        if (hasMount.current) {
            callback();
        }
        else {
            hasMount.current = true;
        }
    }, dependencies);
};
